<template>
    <zeit-prompt v-if="showPrompt" @close="hidePrompt()" ref="prompt" desktopCloseLabel="Schließen" maxWidth="max-w-2xl">
        <template #title>Auslaufende Lizenz</template>
  
        <div class="flex flex-col mb-8 mt-4">
          <p class="mb-4">
            Deine Lizenz für {{ brand.name }} läuft am <span class="font-semibold">{{ formatDatetime(institution.license.valid_until) }}</span> ab. Um weiterhin uneingeschränkt auf alle Funktionen zugreifen zu können, kontaktiere bitte deinen Fachhändler und verlängere deine Lizenz.
          </p>

          <p class="font-semibold mb-4">Wichtig:</p>

          <ul class="list-disc list-outside ml-5 mb-4">
            <li>Du kannst das System noch für <span class="font-semibold">{{ timeUntil(institution.license.restriction_date, true).days + 1 }} Tage</span> bis zum <span class="font-semibold">{{ formatDatetime(institution.license.restriction_date) }}</span> nutzen.</li>
            <li>Nach Ablauf dieser Frist wird der Zugang für Administratoren und Abteilungsleiter gesperrt. Mitarbeiter können Arbeitszeiten zunächst weiterhin erfassen.</li>
            <li>Das Konto inklusive aller Nutzerdaten wird in <span class="font-semibold">{{ timeUntil(institution.license.deletion_date, true).days + 1 }} Tagen</span>  zum <span class="font-semibold">{{ formatDatetime(institution.license.deletion_date) }}</span> unwiderruflich gelöscht.</li>
          </ul>

          <div class="mb-4">
            Bei Fragen oder Problemen steht dir unser <router-link @click="showPrompt = false" :to="{name: 'support'}" class="text-primary-dark font-semibold">Support-Team</router-link> gerne zur Verfügung.
          </div>

          <div class="mb-4">Wir danken dir für dein Verständnis und deine Kooperation.</div>

          <div class="mb-4 font-semibold">
            Dein Team von {{ brand.name }}
          </div>

          <div class="mb-2">Dieser Hinweis wird dir einmalig pro Tag angezeigt.</div>
        </div>

        
      </zeit-prompt>
</template>
  
  <script lang="ts">
    import { defineComponent } from 'vue';
  
    import ZeitCard from '@/components/ui/v2/ZeitCard.vue';
    import ZeitCardItem from '@/components/ui/v2/ZeitCardItem.vue';
    import ZeitPrompt from '@/components/ui/ZeitPrompt.vue';

    import { session } from '@/globals/session';
    import { formatDatetime, timeUntil } from '@/globals/helpers';
    import brand from '@/branding';
    import institutionService from '@/services/institutions';
  
    export default defineComponent({
      components: {
        ZeitCard, ZeitCardItem, ZeitPrompt,
      },
      data() {
        return {
          showPrompt: false,
          institution: session.institution,
        }
      },
      setup() {
        return {
          formatDatetime,
          timeUntil,
          brand,
        }
      },
      methods: {
        hidePrompt() {
          this.showPrompt = false;
          localStorage.setItem(this.getLocalStorageKey(), new Date().toISOString());
        },
        getLocalStorageKey() {
          return `licensePrompt__${localStorage.accessToken.slice(0, 4)}`;
        },        
      },
      async mounted() {
        if (!this.institution || !this.institution.license || this.institution.license.expired) return;
        if (brand.id != 'black') return;
        
        const account = session.getAccount();
        if (account.role != 'admin' && account.role != 'manager') return;

        // Check if the license is expired, we do this here and later to avoid
        // unnecessary requests to the server.
        if (timeUntil(this.institution.license.valid_until, true).days > 8) return;

        // Refresh the license to ensure we have the latest data
        session.setInstitution((await institutionService.list()).data.results[0]);

        // Check again after refresh
        if (timeUntil(session.institution.license.valid_until, true).days > 8) return;

        const lastPrompt = localStorage.getItem(this.getLocalStorageKey());
        if (lastPrompt && new Date(lastPrompt).getDate() == new Date().getDate()) return;

        // This is a workaround to prevent the prompt from being shown if the
        // restriction date is not set for some reason..
        if (isNaN(timeUntil(this.institution.license.restriction_date, true).days)) return;

        this.showPrompt = true;
      },
    })
  </script>
  